import { BufferGeometry, Float32BufferAttribute, Mesh, ShaderMaterial, type Camera, type Scene, type Texture, type WebGLRenderer, type WebGLRenderTarget } from 'three';
import { Pass } from 'three/examples/jsm/postprocessing/Pass.js';

/** Draw the preserved exterior and cabin in ONE render call. A second call to
 * the same MSAA target may lose colour data after Three resolves/invalidates it.
 * Glass samples the previous buffer, never the framebuffer being written. */
export class CockpitPass extends Pass {
  private background: Mesh<BufferGeometry, ShaderMaterial>;
  constructor(private scene: Scene, private camera: Camera, private exterior: (texture: Texture, width: number, height: number) => void) {
    super();
    const geometry = new BufferGeometry();
    geometry.setAttribute('position', new Float32BufferAttribute([-1, -1, 0, 3, -1, 0, -1, 3, 0], 3));
    const material = new ShaderMaterial({
      depthTest: false, depthWrite: false, toneMapped: false,
      uniforms: { tDiffuse: { value: null } },
      vertexShader: 'varying vec2 vUv; void main() { vUv = position.xy * 0.5 + 0.5; gl_Position = vec4(position.xy, 1.0, 1.0); }',
      fragmentShader: 'uniform sampler2D tDiffuse; varying vec2 vUv; void main() { gl_FragColor = texture2D(tDiffuse, vUv); }',
    });
    this.background = new Mesh(geometry, material);
    this.background.name = 'preserved_exterior'; this.background.frustumCulled = false; this.background.renderOrder = -10000;
    this.scene.add(this.background);
  }
  override render(renderer: WebGLRenderer, writeBuffer: WebGLRenderTarget, readBuffer: WebGLRenderTarget) {
    const autoClear = renderer.autoClear;
    try {
      renderer.autoClear = false;
      this.exterior(readBuffer.texture, readBuffer.width, readBuffer.height);
      this.background.material.uniforms.tDiffuse.value = readBuffer.texture;
      renderer.setRenderTarget(this.renderToScreen ? null : writeBuffer);
      renderer.clear();
      renderer.render(this.scene, this.camera);
    } finally { renderer.autoClear = autoClear; }
  }
  override dispose() {
    this.background.removeFromParent();
    this.background.material.uniforms.tDiffuse.value = null;
    this.background.geometry.dispose(); this.background.material.dispose();
  }
}
